import React, { Component } from 'react';
import { GECKO_CONSTS, GeckoModal } from 'ui';
import GeckoRequest from '../services/gecko-request';
import AccountSwitcher from '../services/account-switcher';

class AccountSwitcherModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_account: null,
      accounts: [],
    };
  }

  componentDidMount() {
    GeckoRequest.get('/admin/accounts')
      .then((_accounts) => {
        const accounts = _accounts.map((acc) => ({
          label: `${acc.id} - ${acc.name}`,
          value: acc.id,
        }));
        this.setState({ accounts });
      })
      .catch(console.error);
  }

  modalButtons = [
    {
      name: 'Switch',
      type: 'primary',
      handler: () => {
        AccountSwitcher.switchTo(this.state.selected_account);
      },
    },
  ];

  onChange = (key, val) => {
    this.setState({ [key]: val });
  };

  render() {
    const modalFields = [
      {
        key: 'selected_account',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        label: 'Accounts',
        width: 'col-xs-12',
        options: this.state.accounts,
      },
    ];

    return (
      <GeckoModal
        name="Account Switcher"
        fields={modalFields}
        values={this.state}
        handler={this.onChange}
        btns={this.modalButtons}
      />
    );
  }
}

export default AccountSwitcherModal;
